import axios from "../utils/axios.wrapper";

const normalizeListResponse = (data) => ({
  items: data?.Items || data?.items || [],
  totalCount: data?.TotalCount || data?.totalCount || 0,
});

export const getPayments = async () => {
  const { data } = await axios.get("/payment");
  return normalizeListResponse(data);
};

export const getActivePayments = async () => {
  const { data } = await axios.get("/payment/active");
  return normalizeListResponse(data);
};

export const getInactivePayments = async () => {
  const { data } = await axios.get("/payment/inactive");
  return normalizeListResponse(data);
};

export const getPaymentById = async (id) => {
  const { data } = await axios.get(`/payment/${id}`);
  return data;
};

export const getPaymentsByUserId = async (userId) => {
  const { data } = await axios.get(`/payment/user/${userId}`);
  return normalizeListResponse(data);
};

export const getDepositsByPos = async (posId) => {
  const { data } = await axios.get(`/payment/deposits/${posId}`);
  return normalizeListResponse(data);
};

export const getPaymentsByDateRange = async ({ startDate, endDate }) => {
  const payload = { startDate, endDate };
  const { data } = await axios.post("/payment/daterange", payload);
  return normalizeListResponse(data);
};

export const createPayment = async (payment) => {
  const { data } = await axios.post("/payment", payment);
  return data;
};

export const updatePayment = async (id, payment) => {
  const { data } = await axios.put(`/payment/${id}`, payment);
  return data;
};

export const createBulkPayments = async (payload) => {
  const { data } = await axios.post("/payment/bulk", payload);
  return data.items || data;
};

export const deletePayment = async (id) => {
  const { data } = await axios.delete(`/payment/${id}`);
  return data;
};

export const hardDeletePayment = async (id) => {
  const { data } = await axios.delete(`/payment/hard/${id}`);
  return data;
};

export const refundPayment = async (id) => {
  const { data } = await axios.get(`/payment/refund/${id}`);
  return data;
};

export const replacePayments = async ({ entityType, entityId, payments }) => {
  const payload = { entityType, entityId, payments };
  const { data } = await axios.post("/payment/replace-entity-payments", payload);
  return data;
};

export const paymentsService = {
  getPayments,
  getActivePayments,
  getInactivePayments,
  getPaymentById,
  getPaymentsByUserId,
  getDepositsByPos,
  getPaymentsByDateRange,
  createPayment,
  updatePayment,
  deletePayment,
  hardDeletePayment,
  refundPayment,
  replacePayments,
  createBulkPayments,
};